import styled from 'styled-components'

import theme from '~/truck/theme'
import { getTextStyle } from '~/truck/utils'

export const Button = styled.button.attrs({ type: 'button' })`
  align-items: center;
  background-color: ${props => props.bgColor};
  border-radius: ${theme.dimensions.borderRadius}px;
  border: none;
  color: white;
  cursor: pointer;
  display: flex;
  height: ${theme.dimensions.buttonHeight}px;
  outline: none;
  padding: 0 ${theme.spacing.cozy}px;
  width: 100%;
  ${getTextStyle('h5Semibold')}

  > span {
    flex-grow: 1;
  }
`

export const GoogleIconContainer = styled.div`
  align-items: center;
  background-color: white;
  border-radius: 2px;
  display: inline-flex;
  height: 28px;
  justify-content: center;
  margin-left: 2px;
  width: 28px;
`
